import {
  AppBar,
  Avatar,
  Button,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
// import logo1 from "../assets/mobileBackGround.png";
import logo1 from "../assets/logo.png";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router";
import { useCharactersContext } from "../hooks/Context";
import { set } from "react-hook-form";

const TopMenu = () => {
  const { setShowLogin, setQuestionScores, studentName } =
    useCharactersContext();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/login");
    localStorage.removeItem("accessToken");
    const patternsToRemove = [
      /^selectedOptionsLayout1_/,
      /^selectedOptionsLayout16_/,
      /^selectedOptionsArrayLayout2_/,
      /^selectedOptionsLayout3_/,
      /^selectedOptionsLayout9_/,
      /^crossword-progress-/,
      /^inputValuesLayout11_/,
      /^droppedItemsLayout12_/,
      /^wordsAndImage_/,
      /^droppedWords_/,
      /^inputValuesLayout14_/,
      /^inputValuesLayout15_/,
      /^selectedOptionsPhonics_/,
      /^selectedOptionsSyllabification_/,
      /^selectedOptionsLayout17_/,
      /^selectedOptionsLayout14_/,
    ];

    patternsToRemove.forEach((pattern) => {
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        if (key && pattern.test(key)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach((key) => {
        localStorage.removeItem(key);
      });
    });

    localStorage.removeItem("studentId");
    localStorage.removeItem("presentQuestionPaperId");

    setQuestionScores([]);
    setShowLogin(false);
  };

  return (
    <div>
      <AppBar>
        <Toolbar>
          {isMobile ? (
            <>
              <Avatar
                className="exp-panel-org-desktop-smaller-logo"
                src={logo1}
                alt="logo"
                variant="square"
                sx={{
                  width: "20%",
                  height: "20%",
                }}
              />
            </>
          ) : isTablet ? (
            <>
              <Avatar
                className="exp-panel-org-desktop-smaller-logo"
                src={logo1}
                alt="logo"
                variant="square"
                sx={{
                  width: "10vh", // Set the width to "10vh" for isTablet
                  height: "6%",
                }}
              />
            </>
          ) : (
            <>
              <Avatar
                className="exp-panel-org-desktop-smaller-logo"
                src={logo1}
                alt="logo"
                variant="square"
                sx={{
                  width: "17vh",
                  height: "6%",
                }}
              />
            </>
          )}

          {isMobile || isTablet ? (
            <>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  textAlign: "right",
                  fontSize: "90%",
                  marginRight: "1vh",
                  marginBottom: "1.5vh",
                }}
              >
                <span style={{ fontWeight: "800" }}>Hello</span> {studentName}!
              </Typography>
              <IconButton
                sx={{
                  marginLeft: "auto",
                  "& .MuiSvgIcon-root": {
                    fontSize: "3vh",
                  },
                }}
                onClick={handleClick}
                size="small"
              >
                <LogoutIcon />
              </IconButton>
            </>
          ) : (
            <>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  textAlign: "right",
                  marginRight: "2vh",
                  marginBottom: "2vh",
                  fontSize: "3.5vh",
                }}
              >
                <span style={{ fontWeight: "800" }}>Hello</span> {studentName}!
              </Typography>
              <Button
                variant="contained"
                sx={{
                  marginLeft: "auto",
                  color: "white",
                  borderRadius: "10px",
                }}
                onClick={handleClick}
              >
                Logout
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default TopMenu;
